import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface CollapseToggleButtonProps {
  collapsed: boolean;
  onToggle: () => void;
  className?: string;
}

const CollapseToggleButton: React.FC<CollapseToggleButtonProps> = ({ collapsed, onToggle, className }) => (
  <button
    type="button"
    aria-label={collapsed ? "Expand widget" : "Collapse widget"}
    aria-expanded={!collapsed}
    onClick={(e) => {
      e.stopPropagation();
      onToggle();
    }}
    className={cn(
      "!h-6 !w-6 shrink-0 rounded-lg border border-primary/30 bg-transparent text-primary hover:bg-brand-accent hover:border-[#00FEC1] hover:text-black dark:border-[#4A6B85] dark:text-white flex items-center justify-center transition-colors",
      className
    )}
  >
    <ChevronDown className={cn("h-3.5 w-3.5 transition-transform", collapsed && "rotate-180")} />
  </button>
);

export default CollapseToggleButton;
